import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { Events } from "../events/events.service";
import { Clipboard } from "./clipboard.model";

@Injectable({
    providedIn: 'root'
})
export class ClipboardService {

    private clipboard: BehaviorSubject<Clipboard[]> = new BehaviorSubject([]);

    constructor(
        private events: Events,
    ) {}

    get clipboard$(): Observable<Clipboard[]> {
        return this.clipboard.asObservable(); 
    }

    addToClipboard(clipboard: Clipboard) {
        const clipList = this.clipboard.getValue();
        clipList.push(clipboard);
        this.clipboard.next(clipList);
    }

    discardItem(index: number) {
        const clipList = this.clipboard.getValue();
        if (clipList.length > index) {
            clipList.splice(index, 1);
            this.clipboard.next(clipList);
        }
    }

    clearClipboard() {
        this.clipboard.next([]);
    }

    pasteItem(item: Clipboard) {
        this.events.publish('paste-' + item.type, item.data);
    }
}